/**
 * Hero Slider Functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    const heroSlider = document.querySelector('.hero-slider');
    
    if (!heroSlider) return;
    
    const slidesContainer = heroSlider.querySelector('.hero-slider__slides');
    const slides = heroSlider.querySelectorAll('.hero-slider__slide');
    const prevButton = heroSlider.querySelector('.slider-navigation__button.prev-slide');
    const nextButton = heroSlider.querySelector('.slider-navigation__button.next-slide');
    const currentSlideEl = heroSlider.querySelector('.current-slide');
    const totalSlidesEl = heroSlider.querySelector('.total-slides');
    
    let currentSlideIndex = 0;
    const totalSlides = slides.length;
    let isAnimating = false;
    let slideWidth = 0;
    let isMobile = false;
    let autoplayTimer = null;
    const autoplayInterval = 5000; // 5 seconds
    
    // Touch/swipe variables
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isTouching = false;
    const swipeThreshold = 50; // Minimum distance for a swipe to register
    const swipeAngleThreshold = 30; // Maximum angle deviation for horizontal swipe (in degrees)

    // Check if mobile
    function checkMobile() {
        isMobile = window.innerWidth <= 768;
    }

    // Calculate slide width and positions
    function calculateDimensions() {
        checkMobile();
        
        if (slides.length === 0) return;
        
        if (isMobile) {
            slideWidth = slides[0].offsetWidth; // Use width for horizontal mobile layout
        } else {
            // For desktop, we calculate dynamically in updateSliderPosition
            slideWidth = 0; // Not used in desktop calculation
        }
        
        updateSliderPosition(false); // Update without animation
    }

    // Update slider position
    function updateSliderPosition(animate = true) {
        if (!slidesContainer) return;
        
        if (!animate) {
            slidesContainer.style.transition = 'none';
        } else {
            slidesContainer.style.transition = '';
        }
        
        if (isMobile) {
            // Mobile: horizontal sliding (left/right)
            const translateX = -currentSlideIndex * slideWidth;
            slidesContainer.style.transform = `translateX(${translateX}px)`;
        } else {
            // Desktop: center the active slide
            const viewportWidth = window.innerWidth;
            let slideWidth;
            
            // Calculate slide width based on screen size (matching CSS)
            if (viewportWidth <= 1024 && viewportWidth > 768) {
                // Tablet: use min(90vw, 900px)
                slideWidth = Math.min(viewportWidth * 0.9, 900);
            } else {
                // Desktop: use min(1374px, 100vw - 2rem)
                slideWidth = Math.min(1374, viewportWidth - 32);
            }
            
            const gap = 16; // 1rem in pixels
            
            // Calculate center position more precisely
            const containerCenter = viewportWidth / 2;
            const slideCenter = slideWidth / 2;
            
            // Calculate the offset needed to center the active slide
            const slideAndGapWidth = slideWidth + gap;
            const totalOffset = currentSlideIndex * slideAndGapWidth;
            const translateX = containerCenter - slideCenter - totalOffset;
            
            slidesContainer.style.transform = `translateX(${translateX}px)`;
        }
        
        // Force reflow if no animation
        if (!animate) {
            slidesContainer.offsetHeight;
            slidesContainer.style.transition = '';
        }
    }

    // Update active slide class
    function updateActiveSlide() {
        slides.forEach((slide, index) => {
            slide.classList.toggle('active', index === currentSlideIndex);
        });
    }

    // Initialize slider
    function initSlider() {
        if (totalSlides <= 1) {
            if (slides.length === 1) {
                slides[0].classList.add('active');
            }
            
            if (prevButton) prevButton.disabled = true;
            if (nextButton) nextButton.disabled = true;
            return;
        }
        
        // Set initial active slide
        updateActiveSlide();
        
        // Calculate initial dimensions
        calculateDimensions();
        
        // Update pagination
        updatePagination(currentSlideIndex, totalSlides);
        
        // Add event listeners
        if (prevButton) {
            prevButton.addEventListener('click', goToPrevSlide);
        }
        
        if (nextButton) {
            nextButton.addEventListener('click', goToNextSlide);
        }
    }
    
    // Update pagination display
    function updatePagination(index, total) {
        if (currentSlideEl && totalSlidesEl) {
            currentSlideEl.textContent = String(index + 1).padStart(2, '0');
            totalSlidesEl.textContent = String(total).padStart(2, '0');
        }
    }
    
    // Go to previous slide
    function goToPrevSlide() {
        if (isAnimating || totalSlides <= 1) return;
        
        isAnimating = true;
        
        // Calculate previous index (circular)
        currentSlideIndex = (currentSlideIndex - 1 + totalSlides) % totalSlides;
        
        // Update pagination
        updatePagination(currentSlideIndex, totalSlides);
        
        // Update active slide
        updateActiveSlide();
        
        // Animate to new position
        updateSliderPosition(true);
        
        // Animation complete
        setTimeout(() => {
            isAnimating = false;
        }, 800);
        
        // Restart autoplay after manual navigation
        restartAutoplay();
    }
    
    // Go to next slide
    function goToNextSlide(isAutoplay = false) {
        if (isAnimating || totalSlides <= 1) return;
        
        isAnimating = true;
        
        // Calculate next index (circular)
        currentSlideIndex = (currentSlideIndex + 1) % totalSlides;
        
        // Update pagination
        updatePagination(currentSlideIndex, totalSlides);
        
        // Update active slide
        updateActiveSlide();
        
        // Animate to new position
        updateSliderPosition(true);
        
        // Animation complete
        setTimeout(() => {
            isAnimating = false;
        }, 800);
        
        // Only restart autoplay if this wasn't called by autoplay itself
        if (!isAutoplay) {
            restartAutoplay();
        }
    }
    
    // Handle window resize
    window.addEventListener('resize', function() {
        // Debounce resize events
        clearTimeout(window.sliderResizeTimeout);
        window.sliderResizeTimeout = setTimeout(() => {
            if (!isAnimating) {
                const wasMobile = isMobile;
                calculateDimensions();
                
                // If we switched between mobile/desktop, reset any inline styles
                if (wasMobile !== isMobile) {
                    slidesContainer.style.transition = 'none';
                    updateSliderPosition(false);
                    setTimeout(() => {
                        slidesContainer.style.transition = '';
                    }, 50);
                }
            }
        }, 250);
    });
    
    // Handle image load for proper sizing
    function handleImageLoad() {
        const images = heroSlider.querySelectorAll('.hero-slider__image');
        let loadedImages = 0;
        
        if (images.length === 0) {
            calculateDimensions();
            return;
        }
        
        images.forEach(img => {
            if (img.complete) {
                loadedImages++;
                if (loadedImages === images.length) {
                    calculateDimensions();
                }
            } else {
                img.onload = () => {
                    loadedImages++;
                    if (loadedImages === images.length) {
                        calculateDimensions();
                    }
                };
            }
        });
    }
    
    // Autoplay functionality
    function startAutoplay() {
        if (totalSlides <= 1) return;
        
        stopAutoplay(); // Clear any existing timer
        autoplayTimer = setInterval(() => {
            if (!isAnimating) {
                goToNextSlide(true); // Pass true to indicate this is an autoplay call
            }
        }, autoplayInterval);
    }

    function stopAutoplay() {
        if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    }

    function restartAutoplay() {
        stopAutoplay();
        setTimeout(startAutoplay, 100); // Small delay to ensure smooth restart
    }

    // Touch/swipe event handlers
    function handleTouchStart(e) {
        if (totalSlides <= 1) return;
        
        isTouching = true;
        const touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        
        // Pause autoplay during touch interaction
        stopAutoplay();
    }

    function handleTouchMove(e) {
        if (!isTouching || totalSlides <= 1) return;
        
        const touch = e.touches[0];
        touchEndX = touch.clientX;
        touchEndY = touch.clientY;
    }

    function handleTouchEnd(e) {
        if (!isTouching || totalSlides <= 1) return;
        
        isTouching = false;
        
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        
        // Check if the swipe distance meets the threshold
        if (distance >= swipeThreshold) {
            // Calculate the angle of the swipe
            const angle = Math.abs(Math.atan2(deltaY, deltaX) * 180 / Math.PI);
            
            // Check if it's a horizontal swipe (angle close to 0 or 180 degrees)
            if (angle <= swipeAngleThreshold || angle >= (180 - swipeAngleThreshold)) {
                if (deltaX > 0) {
                    // Swipe right - go to previous slide
                    goToPrevSlide();
                } else {
                    // Swipe left - go to next slide
                    goToNextSlide();
                }
                
                // Prevent default scroll behavior
                e.preventDefault();
            }
        }
        
        // Restart autoplay after touch interaction
        restartAutoplay();
    }

    function handleTouchCancel(e) {
        if (!isTouching) return;
        
        isTouching = false;
        
        // Restart autoplay after touch interaction is cancelled
        restartAutoplay();
    }
    
    // Initialize the slider
    initSlider();
    
    // Handle image loading
    handleImageLoad();
    
    // Add hover pause functionality
    if (heroSlider) {
        heroSlider.addEventListener('mouseenter', stopAutoplay);
        heroSlider.addEventListener('mouseleave', startAutoplay);
        
        // Add touch/swipe event listeners
        heroSlider.addEventListener('touchstart', handleTouchStart, { passive: false });
        heroSlider.addEventListener('touchmove', handleTouchMove, { passive: false });
        heroSlider.addEventListener('touchend', handleTouchEnd, { passive: false });
        heroSlider.addEventListener('touchcancel', handleTouchCancel, { passive: false });
    }
    
    // Pause autoplay when page is not visible
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            stopAutoplay();
        } else {
            startAutoplay();
        }
    });
    
    // Start autoplay
    startAutoplay();
}); 